import { ApiModule, LoggerModule } from "@packages/common";
import { Module } from "@webmotors/ioc";
import { CurrentLocationService } from "./current-location.service";
import { LocationService } from "./location.service";

export const LocationModule: Module = {
  name: "LocationModule",
  modules: [ApiModule, LoggerModule],
  providers: [LocationService, CurrentLocationService],
};
